module.exports = __webpack_public_path__ + "assets/img/TopTradedBAPC.68bba872.png";